import { syncVideo } from '@/api/platform'
import {  getPlatforms } from '@/api/open'

export default {
    components: {
    },
    props: {
        showSyncForm: {
            type: Boolean,
            required: true
        },
    },
    data () {
        return {
            platforms: [],
            labelCol: { span: 4 },
            wrapperCol: { span: 18 },
            loading: false,
            model: {
                platform_id: null,
                cookie: null,
            },
            rules: {
                platform_id: [ { required: true, message: '请选择平台', trigger: 'change' }],
            }
        }
    },
    computed: {},
    mounted () {
        getPlatforms().then(res => { 
            this.platforms = res.data.list || {}
        })
    },
    methods: {
        submit() {
            this.$refs.form.validate(valid => {
                if (!valid) {
                    return false
                }
                this.storeOrUpdate()
            });
        },
        storeOrUpdate() {
            this.loading = true
            syncVideo(this.model).then(res => {
                this.$message.destroy()
                if (res && res.code === 0) {
                    this.$message.success('同步成功')
                    this.$emit('success')
                    this.close()
                } else {
                    this.$message.error(res.message);
                }
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },
        close() {
            this.$refs.form.resetFields()
            this.$emit('update:showSyncForm', false)
        }
    }
}
